import * as XLSX from "xlsx";

const normalizarEncabezado = (value) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

const limpiarValor = (value) =>
  String(value ?? "")
    .trim()
    .replace(/^["']+|["']+$/g, "")
    .trim();

/**
 * Toma una columna de una tabla (arreglo de filas). Si la primera fila contiene
 * `header` se usa esa columna y se omite el encabezado; si no, la primera columna.
 */
const tomarColumna = (rows, header) => {
  let columna = 0;
  let inicio = 0;
  if (header && rows.length) {
    const idx = rows[0].findIndex(
      (celda) => normalizarEncabezado(celda) === normalizarEncabezado(header)
    );
    if (idx >= 0) {
      columna = idx;
      inicio = 1;
    }
  }
  return rows
    .slice(inicio)
    .map((row) => limpiarValor(row[columna]))
    .filter(Boolean);
};

/**
 * Convierte texto pegado (desde Excel, CSV o una lista escrita) en valores.
 * - Con tabulaciones (celdas copiadas de Excel) se interpreta como tabla.
 * - Sin tabulaciones, cada línea puede traer varios valores separados por
 *   coma, punto y coma o (si `splitOnSpaces`) espacios.
 */
export const parseIdsFromText = (text, { header, splitOnSpaces = true } = {}) => {
  if (!text) return [];
  const lines = text.split(/\r?\n/).filter((line) => line.trim() !== "");
  if (!lines.length) return [];

  if (lines.some((line) => line.includes("\t"))) {
    return tomarColumna(
      lines.map((line) => line.split("\t")),
      header
    );
  }

  const separador = splitOnSpaces ? /[,;\s]+/ : /[,;]+/;
  const values = lines
    .flatMap((line) => line.split(separador))
    .map(limpiarValor)
    .filter(Boolean);

  if (
    values.length &&
    header &&
    normalizarEncabezado(values[0]) === normalizarEncabezado(header)
  ) {
    values.shift();
  }
  return values;
};

/** Lee la primera hoja de un archivo CSV/XLS/XLSX y retorna los valores de la columna. */
export const parseIdsFromFile = async (file, { header } = {}) => {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  if (!sheet) return [];
  const rows = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    blankrows: false,
    defval: "",
    raw: false,
  });
  return tomarColumna(rows, header);
};

export const downloadIdTemplate = ({ header, examples = [], fileName }) => {
  const sheet = XLSX.utils.aoa_to_sheet([
    [header],
    ...examples.map((example) => [example]),
  ]);
  sheet["!cols"] = [{ wch: Math.max(header.length + 4, 16) }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Plantilla");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
